<template>
    <div>
      <data-table :table-data="data" :columns="columns" :is-pagination-show="false"></data-table>
    </div>
</template>

<script>
  import DataTable from '../../components/DataTable'
  import Status2CN from "../../filters/Status2CN"
  import {formatMoney} from "../../filters/CommonFilters";

  export default {
    name: "RepayPlanDataTable",
    data() {
      return {

      }
    },
    props: {
      data: {
        type: Object,
        default: ()=>{
          return {
            data: [],
            count: 0
          }
        }
      },
      columns: {
        type: Array,
        default: ()=>{
          return [
            {
              label: '期数',
              field: 'plan__sequenceNo'
            },
            {
              label: '还款日期',
              field: 'plan__repayDate'
            },
            {
              label: '本金',
              field: 'plan__principalAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)+'元'
              }
            },
            {
              label: '利息',
              field: 'plan__interestAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)+'元'
              }
            },
            {
              label: '服务费',
              field: 'plan__lendingFeeAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)+'元'
              }
            },
            {
              label: '其他费用',
              field: 'plan__lendingFeeAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)+'元'
              }
            },
            {
              label: '合计',
              field: 'plan__repayAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)+'元'
              }
            },
            {
              label: '还款状态',
              field: 'plan__repaymentStatus',
              formatter: function (r,c,v) {
                return Status2CN(v)
              }
            },
          ]
        }
      }
    },
    components: {
      DataTable
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/RepayPlanDataTable.vue